import { createContext } from "react";
import { CustomAlert } from "../interfaces/CustomAlert";

const defaultValue = (alert: CustomAlert) => {};
export const AlertContext = createContext(defaultValue);